import { IFacetSelectedValues } from '../types/facets.definitions'; // eslint-disable-line no-unused-vars

/**
 * add/update MULTISELECTBUTTON selectedValues
 * @param {Object} storeFacet
 * @param {string} facetName
 * @param {Array<string>} newSelectedValues
 * @returns {IFacetSelectedValues}
 */
export default function getMultiSelectedValues(storeFacet, facetName, newSelectedValues) {
  const existingIndex = storeFacet.selectedValues.findIndex((item) => item.name === facetName);

  const updatedSelectedValues = [...storeFacet.selectedValues];

  if (existingIndex >= 0) {
    const existingItem = updatedSelectedValues[existingIndex];
    updatedSelectedValues[existingIndex] = {
      ...existingItem,
      selectedValues: [...new Set([...existingItem.selectedValues, ...newSelectedValues])],
    };
  } else {
    updatedSelectedValues.push({
      name: facetName,
      selectedValues: [...newSelectedValues],
    });
  }

  return updatedSelectedValues;
}
